import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import MainPage from './pages/MainPage';
import SsoCallback from './pages/SsoCallback';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          {/* Возврат с гипнозио — вне ProtectedRoute: сюда приходят ещё не вошедшими */}
          <Route path="/sso/callback" element={<SsoCallback />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainPage />
              </ProtectedRoute>
            }
          />
          {/* Прямая ссылка на запись — её дают клиенту в кабинете гипнозио.
              Открывает сверху именно эту запись, ниже — остальные доступные
              и недоступные. Не вошёл — уходит на вход и возвращается сюда. */}
          <Route
            path="/r/:fileId"
            element={
              <ProtectedRoute>
                <MainPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
